<div class="w-75 m-3">
	<div class="w-100 text-end">
		<button (click)="openUploadDialog()" class="mb-3 me-4" mat-raised-button color="primary">Wgraj plik</button>
	</div>
	<input class="d-none" type="file" [multiple]="true" #Input (change)="onDocumentsSelected($event)" />
	<mat-card appearance="outlined">
		<mat-card-title>Wygenerowane przez użytkownika</mat-card-title>
		<mat-card-content>
			<table mat-table [dataSource]="documentList" [trackBy]="trackByDocumentId" class="w-100">
				<ng-container matColumnDef="icon">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let element">
						<i class="fa-solid fa-file me-2"></i>
					</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef>Typ dokumentu</th>
					<td mat-cell *matCellDef="let element">
						{{ element?.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="date">
					<th mat-header-cell *matHeaderCellDef>Utworzył</th>
					<td mat-cell *matCellDef="let element">
						{{ dateService.apiToDateTime(element?.createdAt).date }}
						|
						{{ dateService.apiToDateTime(element?.createdAt).time }}
					</td>
				</ng-container>
				<ng-container matColumnDef="author">
					<th mat-header-cell *matHeaderCellDef>Dodał</th>
					<td mat-cell *matCellDef="let element">
						{{ element?.createdBy?.firstName }}
						{{ element?.createdBy?.lastName }}
						{{ element?.createdBy?.email }}
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr
					role="button"
					(click)="clickDocument(row)"
					mat-row
					*matRowDef="let row; columns: displayedColumns"
				></tr>
			</table>
		</mat-card-content>
	</mat-card>
	@if (reservation.largeFamilyCard) {
		<mat-card class="mt-2" appearance="outlined">
			<mat-card-title>Karta Dużej Rodziny</mat-card-title>
			<mat-card-content>
				<img [src]="reservation.largeFamilyCard" [style.maxWidth]="'700px'" />
			</mat-card-content>
		</mat-card>
	}
</div>
